import { gt } from 'lodash';
import Referentials from './Referentials.json';
import { CaseCalculationPart } from '../interfaces/Case';
import { WidgetPrefill, WidgetTheme } from '../interfaces/Organization';

export const RoleClaimsEnum = {
  Administrator: 'Administrator',
  Admin: 'ADMIN',
  AdminUsers: 'ADMIN_USERS',
  AdminValueList: 'ADMIN_VALUELISTS',
  AdminOrganization: 'ADMIN_ORGANIZATION',
  SAMPLEPAGEV3: 'SAMPLEPAGEV3',
  Agenda: 'AGENDA',
  Dashboard: 'DASHBOARD',
  Evaluation: 'EVALUATION',
  NewCase: 'NEW_CASE',
  Home: 'HOME',
  Case: 'CASE',
  Order: 'ORDER',
  Vehicle: 'VEHICLE',
  Settings: 'SETTINGS',
  ManagerExport: 'MANAGER_EXPORT',
  MavoVehicle: 'MAVO_VEHICLE',
  MavoAgent: 'MAVO_AGENT',
  MavoAdministrator: 'MAVO_ADMINISTRATOR',
  MavoContab: 'MAVO_CONTAB',
  AdminCountryOrganization: 'ADMIN_COUNTRY_ORGANIZATION',
  AdminService: 'ADMIN_SERVICE',
  VehicleSearch: 'VEHICLE_SEARCH',
  Supplier: 'SUPPLIER',
  AdminSupport: 'ADMIN_SUPPORT',
  PowerBi: 'POWERBI',
  OwnerAdmin: 'OWNER_ADMIN',
  ManagerFacturare: 'MANAGER_FACTURARE',
  RaportComenzi: 'RAPORT_COMENZI',
  ManagerComenziAP: 'MANAGER_COMENZI_AP',
  Dealer: 'DEALER',
  UserAdminFurnizori: 'USER_ADMIN_FURNIZORI',
  ConfiguratorExtradiscount: 'CONFIGURATOR_EXTRADISCOUNT',
  ManagerFlota: 'MANAGER_FLOTA',
  ManagerMultiFlota: 'MANAGER_MULTI_FLOTA',
  Sofer: 'SOFER',
  Vanzator: 'VANZATOR',
  ManagerMvo: 'MANAGER_MVO',
  ManagerStockPropriu: 'MANAGER_STOC_PROPRIU',
  AdminComenzi: 'ADMIN_COMENZI',
  TariffPropriu: 'TARIFF_PROPRIU',
  Asigurator: 'ASIGURATOR'
};

export const ProviderCategoryCodeEnum = {
  PARTENER_FLOTA: 'PARTENER_FLOTA'
};

export const OrganizationTypeCode = {
  GT: 'GT',
  SUPPLIER: 'FRZ',
  LEASING: 'LEA',
  REP: 'REP',
  PJ: 'PJ',
  FLOTA: 'FLOTA',
  INSURER: 'ASIG'
};

export const OrganizationLevelTypeCode = {
  HO: 'HO',
  COST: 'COST'
};

export const TariffCategoryCode = {
  REP: 'REP'
};

export const WorkflowFormActionTypeCode = {
  STATUS_TRANSITION: 'TRAN_ST',
  CASE_ALLOCATION: 'CS_ALLOC',
  SEND_MAIL: 'SD_MAIL'
};

export const CommentTypeCode = {
  PUBLIC: 'Public',
  PRIVATE: 'Private',
  INTERNAL: 'Internal',
  SUPPORT_REQUEST: 'SUPPORT_REQUEST',
  SUPPORT_RESPONSE: 'SUPPORT_RESPONSE'
};

export const AttachmentTypeCode = {
  RCA: 'RCA',
  VIC: 'VIC',
  ID: 'ID',
  DL: 'DL',
  IMG: 'IMG',
  OTHER: 'OTHER',
  CONTRACT: 'CONTRACT',
  MAIN_VEHICLE_PHOTO: '104',
  MANUAL_UTILIZARE: 'MANUAL_UTILIZARE',
  WORK_ORDER: 'WORK_ORDER',
  HAND_OVER: 'HAND_OVER',
  INVOICE_REPAIR: 'INVOICE_REPAIR',
  LEFT_SIDE_FRONT: '104',
  CERTIFICAT_CALITATE_SI_ORIGINE: 'CERTIFICAT_CALITATE_SI_ORIGINE',
  APPOINTMENT_PHOTO: 'APPOINTMENT_PHOTO',
  DEVIZ_SERVICE: 'DEVIZ_SERVICE',
  REPAIR_SERVICE_INVOICE_TO_GTM: 'REPAIR_SERVICE_INVOICE_TO_GTM'
};

export const PurchaseOriginCode = {
  NC: '01'
};

export const InvoiceRelatedEntityTypeCode = {
  SUBSCRIPTION: 'SUBSCRIPTION',
  CASE: 'CASE',
  ORGANIZATION: 'ORGANIZATION',
  REPAIR_SERVICE_INVOICE_TO_GTM: 'REPAIR_SERVICE_INVOICE_TO_GTM'
};

export enum InvoiceTypeEnum {
  SUBSCRIPTION = 1,
  REPAIR_INVOICE = 2,
  REPAIR_SERVICE_INVOICE_TO_GTM = 3
}

export const ParametreCode = {
  TVA: 'TVA',
  CURRENCY: 'CUR'
};
export const CalculationTypeCode = {
  ORG: 'ORG',
  ALT: 'ALT'
};
export const CaseStatusTypeCode = {
  DRAFT: 'DRAFT'
};

export const CarPartQualityTypeCode = {
  OE: 'OE',
  OEM: 'OEM',
  AM: 'AM'
};

export const CarPartQualityRatings = [
  {
    CarPartQualityTypeCode: CarPartQualityTypeCode.OE,
    Rating: 3
  },
  {
    CarPartQualityTypeCode: CarPartQualityTypeCode.OEM,
    Rating: 2
  },
  {
    CarPartQualityTypeCode: CarPartQualityTypeCode.AM,
    Rating: 1
  }
];

export const ReportTypeCode = {
  ESTIMATE_OE: 'DEVIZ_OE',
  RENAULT_OFFER: 'RENAULT_OFFER',
  RENAULT_INVOICE: 'RENAULT_INVOICE',
  RENAULT_CONTRACT: 'RENAULT_CONTRACT',
  ADVERT_REPORT: 'ADVERT_REPORT',
  DEVIZ_AUTOWORLD: 'DEVIZ_AUTOWORLD',
  DEVIZ_CLIENT: 'DEVIZ_CLIENT',
  RENAULT_AVIZ_PLATA: 'RENAULT_AVIZ_PLATA',
  RENAULT_FACTURA_LIVRARE: 'RENAULT_FACTURA_LIVRARE',
  DEVIZ_ALT: 'DEVIZ_ALT',
  FISA_EVALUARE_MASINA: 'FISA_EVALUARE_MASINA',
  WORK_ORDER: 'WORK_ORDER',
  HAND_OVER: 'HAND_OVER',
  DEVIZ_REPARATIE: 'DEVIZ_REPARATIE',
  DEVIZ_ALT_PRC: 'DEVIZ_ALT_PRC',
  DEVIZ_REP_AP: 'DEVIZ_REP_AP',
  DEVIZ_REP_OFERTA: 'DEVIZ_REP_OFERTA',
  AFIS_PRET: 'AFIS_PRET',
  CERTIFICAT_CALITATE_SI_ORIGINE: 'CERTIFICAT_CALITATE_SI_ORIGINE'
};

export const InsuredTypeCode = {
  PF: 'PF',
  PJ: 'PJ'
};
export const OrderStatusCode = {
  REP_DRAFT: 'REP_DRAFT',
  REP_LIVRATA: 'REP_LIVRATA',
  REP_PLASATA: 'REP_PLASATA',
  REP_ANULATA: 'REP_ANULATA',
  FZR_IN_LIVRARE: 'FZR_IN_LIVRARE',
  FZR_ACCEPTATA: 'FZR_ACCEPTATA',
  FZR_REFUZATA: 'FZR_REFUZATA',
  FZR_COMANDA_CONFIRMATA: 'FZR_COMANDA_CONFIRMATA',
  FZR_VERIFICARE_LA_FURNIZOR: 'FZR_VERIFICARE_LA_FURNIZOR',
  REP_VERIFICATA_DE_FURNIZOR: 'REP_VERIFICATA_DE_FURNIZOR',
  REP_REINTEROGATED_PARTS: 'REP_REINTEROGATED_PARTS',
  FZR_COMANDA_CONFIRMATA_PARTIAL: 'FZR_COMANDA_CONFIRMATA_PARTIAL',
  FZR_COMANDA_ANULATA: 'FZR_COMANDA_ANULATA'
};

export const WorflowEditableReport = {
  FISA_EVALUARE_MASINA: 'FISA_EVALUARE_MASINA',
  PROCES_VERBAL_PREDARE_PRIMIRE: 'PROCES_VERBAL_PREDARE_PRIMIRE',
  CERTIFICAT_CALITATE_SI_ORIGINE: 'CERTIFICAT_CALITATE_SI_ORIGINE'
};
export const OrderPartStatus = {
  UNAVAILABLE: 'NU_DISP',
  PROCESSED: 'PRC',
  PROCESSING: 'IN_PRC',
  UNORDERED: 'NEC',
  ORDERED: 'ACT',
  RETURNED: 'RET',
  OUT_OF_STOCK: 'LIPSA_STOC',
  PIESA_SELECTATA: 'PIESA_SELECTATA',
  LIVRATA: 'LVR',
  PARTIAL_LIVRATA: 'PART_LVR',
  ANULATA: 'ANULATA',
  CONFIRMATA_PARTIAL: 'PART_PRC',
  ANULATA_FURNIZOR: 'ANULATA_FZR'
};

export const CalculationSectionCodeEnum = {
  PART: 'PART',
  LABOR: 'LABOR',
  PAINT: 'PAINT',
  PAINT_LABOR: 'PAINT_LABOR'
};

export const OrderStatusTypesCode = {
  FZR: 'FZR_',
  REP: 'REP_'
};

export const OfferTypeCode = {
  SELL: 'SELL',
  BUY: 'BUY'
};

export const CurrencyCode = {
  EUR: 'EUR',
  RON: 'RON',
  USD: 'USD',
  CHF: 'CHF'
};

export const ReferentialCode = {
  OrganizationType: 'OrganizationType',
  OrganizationLevel: 'OrganizationLevel',
  CompanyParameter: 'CompanyParameter',
  Currency: 'Currency',
  Country: 'Country',
  Region: 'Region',
  City: 'City',
  TariffCategory: 'TariffCategory',
  TariffTypeGroup: 'TariffTypeGroup',
  Insurer: 'Insurer',
  CarBrands: 'CarBrands',
  CaseType: 'CaseType',
  NewCaseSteps: 'NewCaseSteps',
  OptimizationType: 'OptimizationType',
  FunctionalGroup: 'FunctionalGroup',
  Section: 'Section',
  AttachmentType: 'AttachmentType',
  CaseStatus: 'CaseStatus',
  WorkflowSteps: 'WorkflowStep',
  EmailRecipientType: 'EmailRecipientType',
  CarPartCategory: 'CarPartCategory',
  Report: 'Report',
  ActionType: 'ActionType',
  UserRole: 'UserRole',
  CalculationType: 'CalculationType',
  CarCategory: 'CarCategory',
  CarClass: 'CarClass',
  PolicyType: 'PolicyType',
  PersonType: 'PersonType',
  SolutionValue: 'SolutionValue',
  OrderStatus: 'OrderStatus',
  OrderPartStatus: 'OrderPartStatus',
  FilterType: 'FilterType',
  PaymentType: 'PaymentType',
  PaymentRequestNo: 'PaymentRequestNo',
  VehicleMake: 'Make',
  BodyType: 'BodyType',
  WheelsType: 'WheelsType',
  TractionType: 'TractionType',
  TransmissionType: 'TransmissionType',
  FuelType: 'FuelType',
  TiresType: 'TiresType',
  PaintType: 'PaintType',
  VehicleCondition: 'VehicleCondition',
  PollutionNorm: 'PollutionNorm',
  GuaranteeType: 'GuaranteeType',
  OfferTye: 'OfferType',
  AdvertRegion: 'AdvertRegion',
  AdvertCity: 'AdvertCity',
  QCItemCategory: 'QCItemCategory',
  QCItem: 'QCItem',
  VehicleStatus: 'VehicleStatus',
  Advertiser: 'Advertiser',
  Model: 'Model',
  Color: 'Color',
  AdvertDistrict: 'AdvertDistrict',
  Bank: 'Bank',
  CountryOrigin: 'CountryOrigin',
  Version: 'Version',
  BodyConditionType: 'BodyConditionType',
  WheelConditionType: 'WheelConditionType',
  InvoiceRangeType: 'InvoiceRangeType',
  InvoiceRangeStatus: 'InvoiceRangeStatus',
  FinancialParameter: 'FinancialParameter',
  VehicleType: 'VehicleType',
  MvoDvBattyp: 'MvoDvBattyp',
  PurchaseOrigin: 'PurchaseOrigin',
  SaleChannel: 'SaleChannel',
  MaintenanceOptionalPartName: 'MaintenanceOptionalPartName',
  Refurbished: 'Refurbished',
  VehicleAttachmentType: 'VehicleAttachmentType',
  AlcorParameter: 'AlcorParameter',
  JobType: 'JobType',
  MaintenanceCategory: 'MaintenanceCategory',
  MaintenanceOption: 'MaintenanceOption',
  MaintenancePackage: 'MaintenancePackage',
  OilViscosity: 'OilViscosity',
  CostCenter: 'CostCenter',
  AppointmentCategoryType: 'AppointmentCategoryType',
  ColorRCR: 'ColorRCR',
  BodyTypeRCR: 'BodyTypeRCR',
  EInvoiceStatus: 'EInvoiceStatus',
  BodyCondition: 'BodyCondition',
  InterventionType: 'InterventionType',
  Category: 'Category',
  LeaseProvider: 'LeaseProvider',
  LeaseProviderCategory: 'LeaseProviderCategory',
  ListValues: 'ListValues',
  ListSubCategory: 'ListSubCategory',
  PartOption: 'PartOption',
  PartSelectionOption: 'PartSelectionOption',
  InteriorType: 'InteriorType',
  InteriorColor: 'InteriorColor',
  EntityType: 'EntityType',
  GTPart: 'GTPart',
  Feature: 'Feature',
  OrgAttachmentType: 'OrgAttachmentType',
  MaterialType: 'MaterialType',
  DamageLevel: 'DamageLevel',
  Operation: 'Operation',
  OrganizationSubType: 'OrganizationSubType',
  PartnerClient: 'PartnerClient',
  WorkflowType: 'WorkflowType',
  TiresWidth: 'TiresWidth',
  TiresRatio: 'TiresRatio',
  TiresDiameter: 'TiresDiameter',
  FleetVehicleType: 'FleetVehicleType',
  PaymentMethod: 'PaymentMethod',
  ProviderCategoryType: 'ProviderCategoryType',
  TariffVehicleType: 'TariffVehicleType',
  FleetSupportSection: 'FleetSupportSection',
  FleetSupportSubsection: 'FleetSupportSubsection',
  AttachmentStatus: 'AttachmentStatus',
  DistanceType: 'DistanceType',
  AttachmentCategory: 'AttachmentCategory',
  OfferStatus: 'OfferStatus',
  DamageType: 'DamageType',
  DamageSeverity: 'DamageSeverity'
};

export const ImportAlternativePartsFileHeader = {
  H1: 'COD_ORIGINALA',
  H2: 'COD_ALTERNATIVA',
  H3: 'NUME_ALTERNATIVA',
  H4: 'PRET_UNITAR_ALTERNATIVA',
  H5: 'CALITATE_ALTERNATIVA',
  H6: 'PRODUCATOR',
  H7: 'FURNIZOR',
  H8: 'TIMP_LIVRARE',
  H9: 'CANTITATE_DISPONIBILA',
  H10: 'LOCATIE_STOC',
  H11: 'OBSERVATII'
};

export const ImportOriginalPartsFileHeader = {
  H1: 'COD_ORIGINALA',
  H2: 'NUME_ORIGINALA',
  H3: 'PRET_UNITAR_ORIGINALA',
  H4: 'CALITATE_ORIGINALA',
  H5: 'UNITATI_ORIGINALA'
};

export const ImportCalculationOriginalPartsFileHeader = {
  H1: 'COD',
  H2: 'NUME',
  H3: 'PRET_UNITAR',
  H4: 'CALITATE',
  H5: 'UNITATI',
  H6: 'DISCOUNT',
  H7: 'FURNIZOR',
  H8: 'TIMP_LIVRARE',
  H9: 'PRODUCATOR',
  H10: 'OBSERVATII'
};

export const ValuationLaguageId = {
  en: 19,
  ro: 55
};

export class Constants {
  public static stsAuthority = process.env.REACT_APP_IDENTITY_URL;
  public static clientId = 'ClaimBoxSPA';
  public static clientRoot = process.env.REACT_APP_APP_ROOT;
  public static clientScope =
    'openid profile ApiGateway TariffService OrganizationService CaseService WorkflowService roles AdministratorClientId_api VehicleService';
  public static apiRoot = process.env.REACT_APP_API_ENDPOINT;
}

export const ClientSettings = {
  authority: Constants.stsAuthority,
  client_id: Constants.clientId,
  redirect_uri: `${Constants.clientRoot}callback`,
  silent_redirect_uri: `${Constants.clientRoot}renewcallback`,
  post_logout_redirect_uri: `${Constants.clientRoot}`,
  response_type: 'code',
  scope: Constants.clientScope,
  automaticSilentRenew: true
};

export const CarDetailsSettings = {
  numberOfKm: 1000000
};

export const VehicleAdvertOperationTypes = {
  publish: 'Publish',
  delete: 'Delete'
};

export const RefConstants = {
  vehicleMakeRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.VehicleMake
  ),
  bodyTypeRef: Referentials.referential.find((item) => item.code === ReferentialCode.BodyType),
  wheelsTypeRef: Referentials.referential.find((item) => item.code === ReferentialCode.WheelsType),
  tractionTypeRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.TractionType
  ),
  transmissionTypeRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.TransmissionType
  ),
  fuelTypeRef: Referentials.referential.find((item) => item.code === ReferentialCode.FuelType),
  tiresTypeRef: Referentials.referential.find((item) => item.code === ReferentialCode.TiresType),
  paintTypeRef: Referentials.referential.find((item) => item.code === ReferentialCode.PaintType),
  vehicleConditionRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.VehicleCondition
  ),
  pollutionNormRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.PollutionNorm
  ),
  modelRef: Referentials.referential.find((item) => item.code === ReferentialCode.Model),
  colorRef: Referentials.referential.find((item) => item.code === ReferentialCode.Color),
  personTypeRef: Referentials.referential.find((item) => item.code === ReferentialCode.PersonType),
  attachementTypeRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.AttachmentType
  ),
  regionRef: Referentials.referential.find((item) => item.code === ReferentialCode.AdvertRegion),
  cityRef: Referentials.referential.find((item) => item.code === ReferentialCode.AdvertCity),
  advertiserRef: Referentials.referential.find((item) => item.code === ReferentialCode.Advertiser),
  districtRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.AdvertDistrict
  ),
  bankRef: Referentials.referential.find((item) => item.code === ReferentialCode.Bank),
  countryOriginRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.CountryOrigin
  ),
  invoiceRangeTypeRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.InvoiceRangeType
  ),
  invoiceRangeStatusRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.InvoiceRangeStatus
  ),
  currencyRef: Referentials.referential.find((item) => item.code === ReferentialCode.Currency),
  financialParameterRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.FinancialParameter
  ),
  vehicleTypeRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.VehicleType
  ),
  mvoDvBattypRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.MvoDvBattyp
  ),
  refurbishedRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.Refurbished
  ),
  versionRef: Referentials.referential.find((item) => item.code === ReferentialCode.Version),
  vehicleAttachmentTypeRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.VehicleAttachmentType
  ),
  alcorParameterRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.AlcorParameter
  ),
  guaranteeTypeRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.GuaranteeType
  ),
  colorRCRRef: Referentials.referential.find((item) => item.code === ReferentialCode.ColorRCR),
  bodyTypeRCRRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.BodyTypeRCR
  ),
  bodyConditionRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.BodyCondition
  ),
  eInvoiceRef: Referentials.referential.find((item) => item.code == ReferentialCode.EInvoiceStatus),
  interiorTypeRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.InteriorType
  ),
  interiorColorRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.InteriorColor
  ),
  gtPartRef: Referentials.referential.find((item) => item.code === ReferentialCode.GTPart),
  orgAttachmentTypeRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.OrgAttachmentType
  ),
  materialTypeRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.MaterialType
  ),
  damageLevelRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.DamageLevel
  ),
  operationRef: Referentials.referential.find((item) => item.code === ReferentialCode.Operation),
  organizationSubTypeRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.OrganizationSubType
  ),
  paymentMethodRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.PaymentMethod
  ),
  damageTypeRef: Referentials.referential.find((item) => item.code === ReferentialCode.DamageType),
  damageSeverityRef: Referentials.referential.find(
    (item) => item.code === ReferentialCode.DamageSeverity
  )
};

export enum VehicleStatusCodeEnum {
  Available = 1,
  Sold = 2,
  Repair = 3,
  Reserved = 4,
  Aquisition = 5,
  AcquisitionRefused = 6,
  ForSale = 7,
  LICITATIE = 8,
  INDISPONIBIL = 9,
  COMANDA = 10,
  AVIZ = 11,
  FACTURAT = 12,
  REZERVAT = 13
}

export enum CaseStatusCodeEnum {
  Closed = 2,
  OF_VANZ = 47,
  OE = 'OE',
  AM = 'AM',
  COM_PI = 'COM_PI',
  PRELUAT_SERVICE = 'PRELUAT_SERVICE',
  SOLICITARE_APROBARE_DEVIZ = 'SOLICITARE_APROBARE_DEVIZ',
  REFUZAT_PRC = 'REFUZAT_PRC',
  COMANDA_ATM = 'COMANDA_ATM',
  INITIATED = 'INITIATED',
  IN_ANALIZA = 'IN_ANALIZA',
  WORK_ORDER_GENERATED = 'WORK_ORDER_GENERATED',
  ACTUALIZARE_DEVIZ = 'ACTUALIZARE_DEVIZ',
  PROGRAMARE_REPARATIE_CONFIRMATA = 'PROGRAMARE_REPARATIE_CONFIRMATA',
  SOLICITA_MODIFICARE_DEVIZ = 'SOLICITA_MODIFICARE_DEVIZ',
  ACTUALIZEAZA_CALCULATIE = 'ACTUALIZEAZA_CALCULATIE',
  WAITING_FOR_BILLING_DATA = 'WAITING_FOR_BILLING_DATA',
  CAR_LEAVE_WORKSHOP = 'CAR_LEAVE_WORKSHOP',
  COMANDA_PIESE_NON_STOC = 'COMANDA_PIESE_NON_STOC',
  SUPLIMENTARE_PIESE = 'SUPLIMENTARE_PIESE',
  pse_com = 'pse_com',
  INTEROGARE_PIESE_NON_STOC = 'INTEROGARE_PIESE_NON_STOC',
  SELECTIE_PIESE = 'SELECTIE_PIESE',
  DRAFT = 'DRAFT',
  PROGRAMARE_REPARATIE = 'PROGRAMARE_REPARATIE',
  INVOICE_GENERATED_EXTERNAL = 'INVOICE_GENERATED_EXTERNAL',
  REPAIR_IN_PROGRESS = 'REPAIR_IN_PROGRESS',
  MASINA_PREDATA = 'MASINA_PREDATA',
  GTM_OFFER_VERIFICATION = 'GTM_OFFER_VERIFICATION',
  VERIFICARE_LA_SERVICE = 'VERIFICARE_LA_SERVICE'
}

export enum GuaranteeTypeEnum {
  FG = 'FG'
}

export enum CaseTypeCode {
  AQUISITION = 'ACHIZITIE',
  SALE = 'VANZARE',
  CLAIM = 'CLAIM',
  REP = 'REP',
  OFFER = 'OFFER',
  Avizare = 'Avizare',
  OMV = 'OMV'
}

export enum CaseStatusCode {
  DATE_CLIENT = 'DATE_CLIENT'
}

export const allowedVehicleStatuses = new Map([
  [VehicleStatusCodeEnum.Aquisition, []],
  [VehicleStatusCodeEnum.Available, [VehicleStatusCodeEnum.Repair, VehicleStatusCodeEnum.Reserved]],
  [VehicleStatusCodeEnum.ForSale, []],
  [VehicleStatusCodeEnum.Repair, [VehicleStatusCodeEnum.Available]],
  [VehicleStatusCodeEnum.Reserved, [VehicleStatusCodeEnum.Available]],
  [VehicleStatusCodeEnum.Sold, []],
  [VehicleStatusCodeEnum.AcquisitionRefused, []]
]);

export enum SupplierApiType {
  GetParts = 1,
  Comenzi = 2
}

export type Descripted<T> = {
  [K in keyof T]: {
    readonly id: T[K];
    readonly description: string;
  };
}[keyof T];

export function enumToDescriptedArray<T>(enumeration: T): Descripted<T>[] {
  return (Object.keys(enumeration) as Array<keyof T>)
    .filter((key) => isNaN(Number(key)))
    .filter((key) => typeof enumeration[key] === 'number' || typeof enumeration[key] === 'string')
    .map((key) => ({
      id: enumeration[key],
      description: String(key)
    }));
}

export const AlternativeCode = {
  TAXAMEDIU: 'TAXAMEDIU'
};

export const SupplierCode = {
  AUGSBURG: 'Augsburg',
  AUTONET: 'Autonet',
  ADTOTAL: 'AD Autototal',
  MATEROM: 'Materom',
  CONEX: 'Conex',
  EUROEST: 'Euroest',
  LKQ: 'LKQ',
  NESTE: 'Neste'
};

export const AdditionalInfoCode = {
  PRODUS_NU_POATE_FI_RETURNAT: 'Acest produs nu poate fi returnat'
};

export const EventDetailsFieldsCode = {
  CASENUMBER: 'caseNumber'
};

export enum UploadSizeLimit {
  SizeLimit = 524288000,
  RenaultSelectionPhotoSizeLimit = 5242880
}

export enum GTErrorCode {
  THE_VIN_NUMBER_SENT_DOES_NOT_DECODE_ANY_MODEL = '9'
}

export enum LanguageCode {
  RO = 'ro',
  EN = 'en',
  CZ = 'cz'
}

export enum FuelTypeEnum {
  E = 'E'
}

export const allowedMavoVehicleStatuses = new Map([
  [
    VehicleStatusCodeEnum.INDISPONIBIL,
    [
      VehicleStatusCodeEnum.LICITATIE,
      VehicleStatusCodeEnum.COMANDA,
      VehicleStatusCodeEnum.AVIZ,
      VehicleStatusCodeEnum.FACTURAT
    ]
  ],
  [
    VehicleStatusCodeEnum.LICITATIE,
    [
      VehicleStatusCodeEnum.INDISPONIBIL,
      VehicleStatusCodeEnum.COMANDA,
      VehicleStatusCodeEnum.AVIZ,
      VehicleStatusCodeEnum.FACTURAT
    ]
  ],
  [
    VehicleStatusCodeEnum.COMANDA,
    [
      VehicleStatusCodeEnum.INDISPONIBIL,
      VehicleStatusCodeEnum.LICITATIE,
      VehicleStatusCodeEnum.AVIZ,
      VehicleStatusCodeEnum.FACTURAT
    ]
  ],
  [
    VehicleStatusCodeEnum.AVIZ,
    [
      VehicleStatusCodeEnum.INDISPONIBIL,
      VehicleStatusCodeEnum.LICITATIE,
      VehicleStatusCodeEnum.COMANDA,
      VehicleStatusCodeEnum.FACTURAT
    ]
  ],
  [
    VehicleStatusCodeEnum.FACTURAT,
    [
      VehicleStatusCodeEnum.INDISPONIBIL,
      VehicleStatusCodeEnum.LICITATIE,
      VehicleStatusCodeEnum.COMANDA,
      VehicleStatusCodeEnum.AVIZ
    ]
  ]
]);

export enum MavoVehicleStatusCodeEnum {
  INDISPONIBIL = 'INDISPONIBIL',
  LICITATIE = 'LICITATIE',
  COMANDA = 'COMANDA',
  AVIZ = 'AVIZ',
  FACTURAT = 'FACTURAT'
}

export enum MavoVehicleProvenanceType {
  RCI = 'RCI',
  DVS = 'DVS'
}

export const mavoVehiclesForNirEnabled: string[] = [MavoVehicleStatusCodeEnum.INDISPONIBIL];
export const mavoVehicleStatuses = [
  VehicleStatusCodeEnum.INDISPONIBIL,
  VehicleStatusCodeEnum.LICITATIE,
  VehicleStatusCodeEnum.COMANDA,
  VehicleStatusCodeEnum.AVIZ,
  VehicleStatusCodeEnum.FACTURAT
];

export enum MavoVehicelAttachementTypeCodeEnum {
  IMG = 'IMG',
  OTHER = 'OTHER'
}

export enum MavoImageUploadSizeLimit {
  MaxSizeKB = 1024
}

export const disabledNewMavoVehicleStatuses: string[] = [
  MavoVehicleStatusCodeEnum.LICITATIE,
  MavoVehicleStatusCodeEnum.COMANDA,
  MavoVehicleStatusCodeEnum.AVIZ,
  MavoVehicleStatusCodeEnum.FACTURAT
];
export const enabledVinMavoVehicleStatuses: string[] = [MavoVehicleStatusCodeEnum.INDISPONIBIL];
export const disabledMavoVehicleStatuses: string[] = [
  MavoVehicleStatusCodeEnum.COMANDA,
  MavoVehicleStatusCodeEnum.AVIZ,
  MavoVehicleStatusCodeEnum.FACTURAT
];

export enum MakeExceptionEnum {
  FIAT = 'FIAT',
  ALFA = 'ALFA ROMEO',
  LANCIA = 'LANCIA'
}

export const MakeException = [
  MakeExceptionEnum.FIAT.toString(),
  MakeExceptionEnum.ALFA.toString(),
  MakeExceptionEnum.LANCIA.toString()
];
export const RenaultGoldList = ['06', '05', '04'];

export enum MavoPersonTypeEnum {
  PF = 2,
  PJ = 1
}

export enum MavoOrderStatusCodeEnum {
  TRANSMIS = 'TRANSMIS',
  CONFIRMAT = 'CONFIRMAT'
}

export enum MavoVehicleInvoiceStatusEnum {
  VALIDA = 'VALIDA',
  STORNO = 'STORNO',
  STORNATA = 'STORNATA'
}

export const OriginalPartShortNumberException = ['G0600', 'G1401', 'G2205', 'HG060'];

export enum AppointmentStatusCodeEnum {
  CONFIRMED = 'CONFIRMED',
  INITIATA = 'INITIATA',
  RESCHEDULED = 'RESCHEDULED',
  CANCELED = 'CANCELED',
  ESTIMATE_REJECTED = 'ESTIMATE_REJECTED'
}

export enum InvoiceRangeCodeEnum {
  FACTURA_REPARATIE = 'FACTURA_REPARATIE',
  FACTURA_SERVICE = 'FACTURA_SERVICE',
  AVIZ = 'AVIZ',
  FACTURA = 'FACTURA',
  ANEXA = 'ANEXA'
}

export const OrganizationInvoiceRangeCodes = [
  InvoiceRangeCodeEnum.FACTURA_SERVICE,
  InvoiceRangeCodeEnum.ANEXA
];

export const MavoInvoiceRangeCodes = [InvoiceRangeCodeEnum.AVIZ, InvoiceRangeCodeEnum.FACTURA];

export const renaultMakeCodes = ['RENAULT', 'DACIA'];

export enum TariffCategoryCodeEnum {
  ADAOS = 'ADAOS',
  ADAOS_ASIGURATOR = 'ADAOS_ASIGURATOR',
  ADAOS_ALT_PART = 'ADAOS_ALT_PART',
  DISC = 'DISC',
  MAN = 'MAN'
}

export enum AdvertOptionCodeEnum {
  MAVO = 'MAVO',
  REN = 'REN',
  AUT = 'AUT',
  OLX = 'OLX',
  PLUS_AUTO = 'PLUS_AUTO'
}

export enum OrganizationInterfaceCodeEnum {
  MAVO = 'MAVO',
  RENAULT = 'RENAULT',
  AUTOVIT = 'AUTOVIT',
  OLX = 'OLX',
  PLUS_AUTO = 'PLUS_AUTO'
}

export enum TariffTypeGroupCodeEnum {
  ADD_PARTS = 'ADD_PARTS',
  PSE_ALT = 'PSE_ALT',
  ADAOS_GTM = 'ADAOS_GTM'
}

export enum RoleCodeEnum {
  ADMIN_COUNTRY_ORGANIZATION = 'ADMIN_COUNTRY_ORGANIZATION'
}

export enum OwnStockCodeEnum {
  OWN_STOCK = 'STOC PROPRIU'
}

export const includedTariffTypeGroupCodes = ['MAN', 'DISC'];

export enum CaseTypeCodeEnum {
  REPARATIE = 'REPARATIE',
  MAINTENANCE = 'REP'
}

export enum CountryCodeEnum {
  CZ = 'CZ',
  RO = 'RO'
}

export enum FilterTypeCodeEnum {
  DS = 'DS'
}

export enum AppointmentCategoryTypeCodeEnum {
  MAINTENANCE = 'MAINTENANCE',
  REPAIR = 'REPAIR'
}

export enum PaymentMethodCodeEnum {
  BANK_TRANSFER = 'BANK_TRANSFER',
  CARD = 'CARD'
}

export const DEFAULT_PAYMENT_DAYS = 15;

// List of codes to exclude
export const excludedCodes = [
  CaseStatusCodeEnum.OE.toString(),
  CaseStatusCodeEnum.AM.toString(),
  CaseStatusCodeEnum.SOLICITA_MODIFICARE_DEVIZ.toString(),
  CaseStatusCodeEnum.IN_ANALIZA.toString(),
  CaseStatusCodeEnum.COM_PI.toString(),
  CaseStatusCodeEnum.ACTUALIZEAZA_CALCULATIE.toString(),
  CaseStatusCodeEnum.GTM_OFFER_VERIFICATION.toString(),
  CaseStatusCodeEnum.VERIFICARE_LA_SERVICE.toString()
];

// Statuses where the Carfix-integration "Trimite oferta catre client" button is enabled
export const sendOfferEnabledStatuses = [
  CaseStatusCodeEnum.AM.toString(),
  CaseStatusCodeEnum.GTM_OFFER_VERIFICATION.toString()
];

export enum OrganizationCaseTypeStepCode {
  DOS_NOU = 'DOS_NOU'
}

export const aquisitionWorkflowSectionSteps = ['VALIDARE OFERTA', 'RED_DOSAR'];

export const aquisitionSteps = ['OFERTA ACCEPTATA'];

export const smartBillInvoiceWorkflowSectionSteps = ['S_TEP'];

export const excludedAdvertisers = ['REN', 'MAVO'];

export enum AppointmentPaymentStatus {
  COMPLETED = 'completed'
}

export enum OrderNotificationTemplateEnum {
  VERIFIED_BY_SUPPLIER = 'VERIFIED_BY_SUPPLIER'
}

export const hideButtonsSectionSteps = ['CAZ_INCHIS'];

export const nontStockRoles = ['VD'];

export const nonStockCheckedOERoles = ['USER ATM'];

export enum MavoAuctionStatusEnum {
  TERMINATA = 'TERMINATA',
  STOPATA = 'STOPATA'
}

export enum MavoLanguageTranslationEnum {
  RO = 'ro'
}

export enum EInvoiceStatusEnum {
  VERIFICATION_SUCCESS = 'VERIFICATION_SUCCESS',
  VERIFICATION_FAILED = 'VERIFICATION_FAILED',
  ERROR = 'ERROR',
  PENDING = 'PENDING'
}

export enum InvoiceTypeCodeEnum {
  FACTURA = '380',
  FACTURA_CORECTATA = '384'
}

export enum AuctionOfferStatusEnum {
  AUCTION_WINNER = 'AUCTION_WINNER',
  AUCTION_LOSER = 'AUCTION_LOSER',
  AUCTION_OFFER_EXCEEDED = 'AUCTION_OFFER_EXCEEDED',
  AUCTION_LAST_BIDDER = 'AUCTION_LAST_BIDDER'
}

export enum NotifySupportTemplateEnum {
  CASE_NOTIFY_SUPPORT = 'CASE_NOTIFY_SUPPORT',
  CASE_SUPPORT_RESPONSE = 'CASE_SUPPORT_RESPONSE',
  GENERAL_NOTIFY_SUPPORT = 'GENERAL_NOTIFY_SUPPORT'
}

export enum PowerBiReportCodeEnum {
  POWER_BI_ORDERS = 'POWER_BI_ORDERS'
}

export const nonStockWorkflowSectionSteps = ['PT_OFERTA'];

export const oilCupiCodes = ['G0600', 'G1401', 'G2205', 'HG060'];

export enum SimulatorRateClientTypeEnum {
  PJ = 'PJ',
  PF = 'PF'
}

export const excludedReportTypes = [
  ReportTypeCode.DEVIZ_REP_AP,
  WorflowEditableReport.FISA_EVALUARE_MASINA,
  WorflowEditableReport.PROCES_VERBAL_PREDARE_PRIMIRE,
  WorflowEditableReport.CERTIFICAT_CALITATE_SI_ORIGINE
];

export enum CreateAcquisitionCaseTemplateEnum {
  NEW_ACQUISITION_CASE = 'NEW_ACQUISITION_CASE'
}

export enum EmailTemplateCodeEnum {
  GTM_OFFER_VERIFICATION_NOTIFICATION = 'GTM_OFFER_VERIFICATION_NOTIFICATION'
}

export const VehicleAttachmentTypeCodeOrder = ['104', '199', '105', '108', '106', '102'];

export enum GTOperationEnum {
  SU = 'SU',
  PA = 'PA',
  RE = 'RE'
}

export enum VOVehicleType {
  VP = 'VP',
  VU = 'VU'
}

export const excludedCancelAppointmentStatuses = [
  AppointmentStatusCodeEnum.CANCELED.toString(),
  AppointmentStatusCodeEnum.ESTIMATE_REJECTED.toString()
];

export const advertOptionToOrganizationInterfaceCodeMap: Record<
  AdvertOptionCodeEnum,
  OrganizationInterfaceCodeEnum
> = {
  [AdvertOptionCodeEnum.MAVO]: OrganizationInterfaceCodeEnum.MAVO,
  [AdvertOptionCodeEnum.REN]: OrganizationInterfaceCodeEnum.RENAULT,
  [AdvertOptionCodeEnum.AUT]: OrganizationInterfaceCodeEnum.AUTOVIT,
  [AdvertOptionCodeEnum.OLX]: OrganizationInterfaceCodeEnum.OLX,
  [AdvertOptionCodeEnum.PLUS_AUTO]: OrganizationInterfaceCodeEnum.PLUS_AUTO
};

export enum WorkflowStepCodeEnum {
  GO_TO_CALCULATION = 'GO_TO_CALCULATION'
}

export const ALTERNATIVE_SPARE_USE_OPTIONS = [
  { value: 1, label: 'No (1)' },
  { value: 2, label: 'Yes (2)' },
  { value: 3, label: 'Only (3)' }
] as const;

export enum ApplicationCodeEnum {
  FLEET = 'FLEET',
  CONNECT = 'CONNECT'
}

export enum TariffTypeCodeEnum {
  PSE = 'PSE'
}

export enum ImportTemplateCodeEnum {
  FLEET_CAR_IMPORT_TEMPLATE = 'FLEET_CAR_IMPORT_TEMPLATE',
  FLEET_PROVIDER_IMPORT_TEMPLATE = 'FLEET_PROVIDER_IMPORT_TEMPLATE',
  ORGANIZATION_IMPORT_TEMPLATE = 'ORGANIZATION_IMPORT_TEMPLATE',
  WORKFLOW_TARIFF_IMPORT_TEMPLATE = 'WORKFLOW_TARIFF_IMPORT_TEMPLATE',
  VEHICLE_VQ_REQUERY_IMPORT_TEMPLATE = 'VEHICLE_VQ_REQUERY_IMPORT_TEMPLATE',
  GT_SUPPLIER_MAPPING_IMPORT_TEMPLATE = 'GT_SUPPLIER_MAPPING_IMPORT_TEMPLATE',
  GT_PART_MAPPING_IMPORT_TEMPLATE = 'GT_PART_MAPPING_IMPORT_TEMPLATE',
  PART_MAPPING_IMPORT_TEMPLATE = 'PART_MAPPING_IMPORT_TEMPLATE'
}

// Total number of suppliers queried (temporary hardcoded until wired to real data).
export const SUPPLIERS_TOTAL = 7;

// Import template headers + example rows for the downloadable original/alternative part files.
export const ORIGINAL_PARTS_IMPORT_TEMPLATE = [
  ImportOriginalPartsFileHeader.H1,
  ImportOriginalPartsFileHeader.H2,
  ImportOriginalPartsFileHeader.H3,
  ImportOriginalPartsFileHeader.H4,
  ImportOriginalPartsFileHeader.H5
];

export const ALTERNATIVE_PARTS_IMPORT_TEMPLATE = [
  ImportAlternativePartsFileHeader.H1,
  ImportAlternativePartsFileHeader.H2,
  ImportAlternativePartsFileHeader.H3,
  ImportAlternativePartsFileHeader.H4,
  ImportAlternativePartsFileHeader.H5,
  ImportAlternativePartsFileHeader.H6,
  ImportAlternativePartsFileHeader.H7,
  ImportAlternativePartsFileHeader.H8,
  ImportAlternativePartsFileHeader.H9,
  ImportAlternativePartsFileHeader.H10,
  ImportAlternativePartsFileHeader.H11
];

export const ORIGINAL_PARTS_IMPORT_EXAMPLE = [
  '0W20',
  'Ulei de motor',
  45.5,
  CarPartQualityTypeCode.OE,
  1
];
export const ALTERNATIVE_PARTS_IMPORT_EXAMPLE = [
  '41009629102',
  '41009629102-ALT',
  'Ulei de motor',
  39.9,
  CarPartQualityTypeCode.AM,
  'Castrol',
  '6844726',
  '2 zile',
  10,
  'Depozit 1',
  '-'
];

// Sample estimate for the Branding document live preview.
export const BRANDING_PREVIEW_PARTS: Partial<CaseCalculationPart>[] = [
  { name: 'Capotă', repairMethod: 'Vopsire', pieceNr: 1, originalPrice: 882 },
  { name: 'Ușă față stânga', repairMethod: 'Reparație', pieceNr: 1, originalPrice: 418 }
];

// Branding logo validation: format, max size, recommended min resolution.
export const BRANDING_LOGO_ACCEPTED_TYPES = ['image/png', 'image/jpeg'];
export const BRANDING_LOGO_MAX_SIZE_BYTES = 2 * 1024 * 1024;
export const BRANDING_LOGO_MIN_WIDTH = 300;
export const BRANDING_LOGO_MIN_HEIGHT = 100;

// FNOL SDK is served from the CDN; the integration snippet only references it.
export const WIDGET_SDK_URL = 'https://test.carfixconnect.ro/fnol-2d/carfix-fnol.min.js';
export const WIDGET_API_BASE_URL_TEST = 'https://test-api.carfixconnect.ro/claimbox.Apigateway/api';
export const WIDGET_API_BASE_URL_PROD = 'https://app.carfixconnect.ro:8081/claimbox.Apigateway/api';
export const WIDGET_DEFAULT_LOCALE = 'ro';

// Sample data for the integration snippet; the insurer replaces it with real data.
export const WIDGET_PREFILL_SAMPLE: WidgetPrefill = {
  eventDetails: {
    caseNumber: 'CL/33233161',
    policyNumber: 'RO-2026-00123',
    eventDate: '2026-07-10',
    region: 'Bucuresti',
    eventPlace: 'Romania BUCURESTI BUCURESTI SPALATORIE SELF STRADA ZETARI'
  },
  vehicle: {
    vin: 'VF1RHN00377383719',
    plateNumber: 'B898AMB',
    make: 'RENAULT',
    model: 'AUSTRAL',
    bodyType: 'Sport Utility Vehicle',
    vehicleTypeCode: 'M1',
    numberOfKilometers: 45000
  },
  client: {
    personTypeId: 1,
    firstName: 'Ion',
    lastName: 'Popescu',
    phone: '+40761000000',
    email: 'ion@example.ro',
    address: 'Str. Exemplu 1, Bucuresti'
  }
};

// Theme sample matching the documentation example.
export const WIDGET_THEME_SAMPLE: WidgetTheme = {
  primaryColor: '#0E7C86',
  logoUrl: 'https://asigurator.ro/logo.png'
};

export enum DistanceTypeCode {
  FAR = 'FAR',
  CLOSE = 'CLOSE'
}

// Accepted values for the widget prefill; shown in the integration snippet so the integrator knows the options.
export const WIDGET_REGION_VALUES: string[] = [
  'Alba',
  'Arad',
  'Arges',
  'Bacau',
  'Bihor',
  'Bistrita-Nasaud',
  'Botosani',
  'Braila',
  'Brasov',
  'Bucuresti',
  'Buzau',
  'Calarasi',
  'Caras-Severin',
  'Cluj',
  'Constanta',
  'Covasna',
  'Dambovita',
  'Dolj',
  'Galati',
  'Giurgiu',
  'Gorj',
  'Harghita',
  'Hunedoara',
  'Ialomita',
  'Iasi',
  'Ilfov',
  'Maramures',
  'Mehedinti',
  'Mures',
  'Neamt',
  'Olt',
  'Prahova',
  'Salaj',
  'Satu Mare',
  'Sibiu',
  'Suceava',
  'Teleorman',
  'Timis',
  'Tulcea',
  'Valcea',
  'Vaslui',
  'Vrancea'
];

export const WIDGET_BODY_TYPE_VALUES: string[] = [
  'Hatchback',
  'Wagon',
  'Sedan',
  'Sport Utility Vehicle',
  'Minivan',
  'Coupe',
  'Mini Mpv',
  'Convertible',
  'Targa',
  'Micro Car',
  'Cargo Van',
  'Pickup',
  'Combi',
  'Chassis Cab',
  'Passenger Van',
  'Car Van',
  'Drop Side',
  'Campervan',
  'Cutaway',
  'Parcel Van',
  'Tipper',
  'Off-Road Commercial',
  'Commercial Hatch',
  'Window Van',
  'Car Pickup',
  'Chassis Cowl',
  'Double Chassis Cab',
  'Commercial Wagon'
];

export enum PartMappingTabEnum {
  List = 0,
  Tree = 1
}
